import script from "./TableHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeader.vue?vue&type=script&setup=true&lang=js"

import "./TableHeader.vue?vue&type=style&index=0&id=6f8a6606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8a6606"]])

export default __exports__